
import { FunctionComponent, useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, CircularProgress } from '@mui/material';
import StajBursBasvuruAPI from "../../../apis/OB/Get/StajBursBasvuruAPI";
import { displayValue } from "../../../helpers/TodayDate";
import SessionStorageService from "../../../services/StorageService";


const StajBursBasvuruTakip: FunctionComponent<any> = (props) => {
  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const user=SessionStorageService.getUserInfo()

  useEffect(() => {
    setIsLoading(true);
    StajBursBasvuruAPI.getStajBursBasvuruListe(
        user.tcKimlikNo,
      undefined,
      undefined
    )
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error('Error fetching data:', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  return (
    <div style={{ width: "100%", padding: "0 5%", fontSize: "0.9rem" }}>
      {isLoading ? (
        <CircularProgress style={{ display: 'block', margin: 'auto', marginTop: '20%' }} />
      ) : (
        <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Başvuru No</TableCell>
                <TableCell>Başvuru Tarihi</TableCell>
                <TableCell>Başvuru Türü</TableCell>
                <TableCell>Sonuç</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{displayValue(item.basvuruNo)}</TableCell>
                  <TableCell>{displayValue(item.basvuruTarihi)}</TableCell>
                  <TableCell>{displayValue(item.basvuruTuruAdi)}</TableCell>
                  <TableCell>{displayValue(item.basvuruSonuc)}</TableCell>
                </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={4} />
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[6, 10, 18]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      )}
      {!isLoading && data.length === 0 && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>Veri bulunamadı!</div>
      )}
    </div>
  );
};

export default StajBursBasvuruTakip;
